<script setup lang="ts">
import { computed, ComputedRef, defineProps } from 'vue';
import AddTeamButton from './AddTeamButton.vue';
import TeamUser from '../../../types/teamUser';

const props = defineProps<{
  owner: boolean;
  editable: boolean;
  team: TeamUser[];
  addAction?: () => void;
}>();

const count: ComputedRef<number> = computed(() => {
  if (props.team.length > 5) {
    return props.team.length - 5;
  }
  return 0;
});
const teamImages = computed(() => props.team.slice(0, 5).map((item) => item.image));
</script>

<template>
  <div class="flex items-center gap-[6px]">
    <div class="flex items-center">
      <div
        v-for="(teamImage, index) in teamImages"
        :key="index"
        class="flex h-[24px] w-[24px] items-center justify-center"
        :class="{ 'ml-[-8px]': (index as number) > 0 }"
      >
        <img :src="teamImage" alt="" class="h-[20px] w-[20px] overflow-hidden rounded-10" />
      </div>
      <span v-if="count > 0" class="font-ibm ml-xxs text-[14px] text-black dark:text-gray-500">+{{ count }}</span>
    </div>
    <div v-if="props.editable" class="hidden laptop:block">
      <AddTeamButton :add-action="props.addAction" />
    </div>
  </div>
</template>
